import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { RequisitionItemPayload, RequisitionPayload, RequisitionResponse } from "@/types/interface/requisition";

export const useRequisitionItemStore = defineStore("requisitionItemStore", () => {
  const item = ref<RequisitionResponse>();
  const items = ref<RequisitionResponse[]>([]);

  function initItems(data: any) {
    items.value = data?.data;
  }

  function addNewItem(data: any) {
    item.value = data;
  }

  async function dispatchCreate(payload: RequisitionItemPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.requisitionItem.create(payload);
        addNewItem(data);
        return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchCheckExistingRequest(idVessel: number, idItem: number, idVariant?: number) : Promise<APIResponse<null>> {
    try {
      const res = await API.requisitionItem.checkExistingRequest(idVessel, idItem, idVariant);
        return res.data;
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data;
      return handleResponseError(errorResponseData)
    }
  }

  return {
    item,
    items,
    initItems,
    dispatchCreate,
    dispatchCheckExistingRequest,
  };
});